module.exports = __webpack_public_path__ + "fonts/Inter-Bold.cef517a1.ttf";